<template>
	<div v-if="element.hasChildren">
		<subcomponents
			:isEditable="isEditable"
			:style="customStyle"
			@updateComp="
				data => {
					element.items = data
				}
			"
			:componenti="element.items"
			:children="element.hasChildren"
		></subcomponents>
	</div>
</template>
<script>
export default {
	name: "RowComponent",
	components: { Subcomponents: () => import("../../components/subcomponents.vue") },
	props: {
		element: {
			required: true,
			type: Object
		},
		isEditable: {
			required: true,
			type: Boolean
		}
	},
	data() {
		return {
			customStyle: {
				"flex-direction": "row",
				display: "flex",
				"justify-content": (() => {
					switch (this.element.type) {
						case "align-left":
							return "left"
						case "align-right":
							return "right"
						case "align-center":
						case "row":
						default:
							return "center"
					}
				})()
			}
		}
	}
}
</script>
<style scoped></style>
